import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, Validators, UntypedFormControl, FormArray } from '@angular/forms';
import { IxellAPIService, IColorMatchingV1, Roles, ICtcV1, ICompanyV1, IUserV1 } from '../../tools/api.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { Utils } from 'src/app/tools/utils';
import { Country } from 'src/app/entities/Constants';
import { HeaderService } from 'src/app/tools/header.service';
import { MatStepper } from '@angular/material/stepper';
import { share } from 'rxjs/operators';
import { Technologie } from 'src/app/tools/contretypage.service';

class CheckboxElementContretyper {
  id: number;
  text: string;
  value: number;
}

class CheckboxQuality {
  id: number;
  text: string;
  value: boolean;
}

@Component({
  selector: 'app-colormatching',
  templateUrl: './colormatching.component.html',
  styleUrls: ['./colormatching.component.scss'],
  providers: [{
    provide: STEPPER_GLOBAL_OPTIONS, useValue: { showError: true }
  }]
})
export class ColormatchingComponent implements OnInit {

  countries: Country[] = [];
  languages: any[] = [];
  manufacturerList: string[];
  ctcList: string[];
  codePostalList: string[];
  companyList: ICompanyV1[];

  allCheckboxElementContretyper: CheckboxElementContretyper[] = [
    { id: 1, text: "contretypage.elemDecoupe", value: 1 },
    { id: 2, text: "contretypage.trappeEssence", value: 2},
    { id: 3, text: "contretypage.elemCarrosserie", value: 3 },
    { id: 4, text: "contretypage.Autres", value: 4 }
  ];

  allCheckboxQuality: CheckboxQuality[] = [{ id: 1, text: "IXELLTECH", value: false }, { id: 2, text: "OXELIA", value: false }, { id: 3, text: "HS2", value: false }];

  companyForm = new UntypedFormGroup({
    socialReason: new UntypedFormControl('', [Validators.required]),
    address: new UntypedFormControl('', [Validators.required]),
    postalCode: new UntypedFormControl('', [Validators.required]),
    city: new UntypedFormControl('', [Validators.required]),
    country: new UntypedFormControl('', [Validators.required])
  })

  userForm = new UntypedFormGroup({
    name: new UntypedFormControl('', [Validators.required]),
    firstname: new UntypedFormControl('', [Validators.required]),
    mail: new UntypedFormControl('', [Validators.email, Validators.required]),
    phone: new UntypedFormControl(''),
    mobile: new UntypedFormControl('', [Validators.required]),
    language: new UntypedFormControl('', [Validators.required])
  })

  ctcForm = new UntypedFormGroup({
    name: new UntypedFormControl(''), //, [Validators.required]
    firstname: new UntypedFormControl(''), // , [Validators.required]
    mail: new UntypedFormControl(''), // , [Validators.email]
    phone: new UntypedFormControl(''),
    idCtc: new UntypedFormControl('')
  })

  colorMatchingForm = new UntypedFormGroup({
    brandVehicle: new UntypedFormControl(''),
    modelVehicle: new UntypedFormControl(''),
    yearVehicle: new UntypedFormControl(''),
    elementAContretyper: new UntypedFormControl('', [Validators.required]),
    designationOriginElement: new UntypedFormControl(''),
    colorOriginElement: new UntypedFormControl('', [Validators.required]),
    designationFinalElement: new UntypedFormControl(''),
    codePainting: new UntypedFormControl(''),
    designationPainting: new UntypedFormControl(''),
    paintQuality: new UntypedFormControl('', [Validators.required, Validators.minLength(1)]),
    comment: new UntypedFormControl('')
  })

  private manufacturerSub: any;
  private roleSub: any;
  private ctcSub: any;
  private userSub: any;
  private companySub: any;
  private colorMatchingSub: any;

  win: any;
  isSend = false;
  completed: boolean = false;
  state: string;
  bCheckCTC: boolean;
  bCheckUser: boolean;
  idContretypage: number = 0;
  elementContretyper: string = "";

  user: IUserV1;
  userCompany: ICompanyV1;
  ctc: ICtcV1;
  colorMatchingRequest: IColorMatchingV1;
  colorMatchingUser: IColorMatchingV1;
  companiesCM: IColorMatchingV1[];
  usersCM: IColorMatchingV1[];
  Utils = Utils;
  role: Roles = Roles.Unknown;
  Technologie = Technologie;

  constructor(public dialog: MatDialog, private apiService: IxellAPIService, private router: Router, private headerService: HeaderService) { }

  

  ngOnInit() {

    this.headerService.changeCanBack(true);
    this.colorMatchingUser = new IColorMatchingV1();
    this.colorMatchingRequest = new IColorMatchingV1();
    this.countries = Utils.countries();
    this.languages = Utils.languages();
    this.roleSub = this.headerService.currentRole.subscribe(role => {
      this.role = role
    }, error => {
      console.log(error);
      if (this.roleSub != null) this.roleSub.unsubscribe();
    });
    if (Utils.isUserIxell(this.role)) {
      this.userSub = this.apiService.getUserAndCompany().subscribe(data => {
        if (data) {
          this.user = data;
          this.colorMatchingUser.userID = data.userID;
          this.colorMatchingUser.userCompanyID = data.company.companyId;
          this.userForm.setValue({
            name: data.name,
            firstname: data.firstname,
            mail: data.mail,
            phone: data.phone,
            mobile: data.mobile,
            language: data.language
          });
          this.companyForm.setValue({
            socialReason: data.company.socialReason,
            address: data.company.address,
            postalCode: data.company.postalCode,
            city: data.company.city,
            country: data.company.country
          })
        }
      }, error => {
        console.log(error);
        if (this.userSub != null) this.userSub.unsubscribe();
      });
    }
    else if (Utils.isCTC(this.role)) {
      this.ctcSub = this.apiService.getCTC().subscribe(data => {
        if (data) {
          this.ctc = data;
          this.ctcForm.setValue({
            name: data.name,
            firstname: data.firstname,
            mail: data.mail,
            phone: data.phone,
            idCtc: data.idCtc
          });
        }
      }, error => {
        console.log(error);
        if (this.userSub != null) this.userSub.unsubscribe();
      })
    }
    this.colorMatchingForm.controls["brandVehicle"].setValue("");
    this.colorMatchingForm.controls["modelVehicle"].setValue("");
    this.colorMatchingForm.controls["yearVehicle"].setValue("");
  }

  ngOnDestroy() {
    if (this.manufacturerSub != null) this.manufacturerSub.unsubscribe();
    if (this.roleSub != null) this.roleSub.unsubscribe();
    if (this.ctcSub != null) this.ctcSub.unsubscribe();
    if (this.userSub != null) this.userSub.unsubscribe();
    if (this.colorMatchingSub != null) this.colorMatchingSub.unsubscribe();
  }

  /**
   * 
   **/
  updatePaintQuality($event: any, checkbox: CheckboxQuality) {
    let checked = $event.checked;

    this.allCheckboxQuality.find(x => x.id == checkbox.id).value = checked;
    if (checked) {
      switch (checkbox.id) {
        case 1:
          this.allCheckboxQuality.find(x => x.id == 2).value = false;
          break;
        case 2:
          this.allCheckboxQuality.find(x => x.id == 1).value = false;
          break;
        case 3:
          break;
        default:
          break;
      }
    }

    let checkboxQuality = this.allCheckboxQuality.filter(x => x.value).map(x => x.id);

    let string_checkboxQuality = "";
    if (checkboxQuality.length > 0)
      string_checkboxQuality = checkboxQuality.join(",");
    this.colorMatchingForm.patchValue({
      paintQuality: string_checkboxQuality
    });
  }

  updateElementAContretyper(checkbox: CheckboxElementContretyper) {

    var elem = document.getElementById("colorMatchingForm-designationOriginElement");
    var field = document.getElementById("mat-form-field-designationOriginElement");
    switch (checkbox.value) {
      case 3:
        this.colorMatchingForm.controls['designationOriginElement'].setValue(""); 
        elem.setAttribute("aria-required", "true");
        field.style.display = "block";
        this.elementContretyper = document.getElementsByClassName("translate-elementAContretyper")[checkbox.value - 1].textContent + " : ";
        break;
      case 4:
        this.colorMatchingForm.controls['designationOriginElement'].setValue(""); 
        elem.setAttribute("aria-required", "true");
        field.style.display = "block";
        this.elementContretyper = document.getElementsByClassName("translate-elementAContretyper")[checkbox.value - 1].textContent + " : ";
        break;
      default:
        elem.setAttribute("aria-required", "false");
        field.style.display = "none";
        this.colorMatchingForm.controls['designationOriginElement'].setValue(document.getElementsByClassName("translate-elementAContretyper")[checkbox.value - 1].textContent);       
        break;
    }
  }

  getCTCByPhone() {
    this.ctcSub = this.apiService.getCtcByPhone(this.ctcForm.controls['phone'].value).subscribe(data => {
      this.ctc = this.ctcForm.value;
      if (data) {
        this.ctc.idCtc = data.idCtc;
        this.ctcForm.setValue({
          name: data.name,
          firstname: data.firstname,
          mail: data.mail,
          phone: data.phone,
          idCtc: data.idCtc
        });
      }
    });
  }

  getCompanyByCP() {
    if (this.companyForm.controls['postalCode'].value != "") {
      this.companiesCM = [];
      this.userForm.reset();
      this.companyForm.controls['socialReason'].reset();
      this.companyForm.controls['address'].reset();//.setValue("");
      this.companyForm.controls['city'].reset();//.setValue("");
      this.companyForm.controls['country'].reset();//.setValue("");
      this.companySub = this.apiService.getCompaniesByCP(this.companyForm.controls['postalCode'].value).subscribe(data => {
        if (data) {
          this.companiesCM = data;
        }
      });
    } else {
      this.companyForm.reset();
      this.companiesCM = [];
    }
  }

  SelectCompany(company: IColorMatchingV1) {
    this.colorMatchingUser.userCompanyID = company.userCompanyID;
    this.colorMatchingUser.colorUserID = company.colorUserID;
    this.companyForm.controls['address'].setValue("");
    this.companyForm.controls['city'].setValue("");
    this.companyForm.controls['country'].setValue("");
    this.userForm.reset();
    this.userSub = this.apiService.getUserCMById(company.userCompanyID, company.colorUserID).subscribe(data => {
      this.companyForm.controls['address'].setValue(company.company_Address);
      this.companyForm.controls['city'].setValue(company.company_City);
      this.companyForm.controls['country'].setValue(company.company_Country);
      this.companyForm.patchValue({
        postalCode: company.company_PostalCode
      });
      this.colorMatchingUser.userID = data[0].userID;
      this.userForm.setValue({
        name: data[0].user_Name,
        firstname: data[0].user_Firstname,
        mail: data[0].user_Mail,
        phone: data[0].user_Phone,
        mobile: data[0].user_Mobile,
        language: data[0].user_Language
      });
    })
  }

  checkUser(stepper: MatStepper) {

    if (this.userForm.valid && this.companyForm.valid) {
      stepper.next();
    }
  }

  checkCTC(stepper: MatStepper) {

    this.ctc = this.ctcForm.value;
    if (this.ctcForm.valid)
      stepper.next();
  }

  selectManufacturers() {

    if (this.colorMatchingForm.value.brandVehicle.length > 0 && this.colorMatchingForm.value.brandVehicle != "DIVERSE") {
      document.getElementById("colorMatchingForm-modelVehicle").setAttribute("aria-required","true");
      document.getElementById("colorMatchingForm-yearVehicle").setAttribute("aria-required", "true");
    } else {
      document.getElementById("colorMatchingForm-modelVehicle").setAttribute("aria-required", "false");
      document.getElementById("colorMatchingForm-yearVehicle").setAttribute("aria-required", "false");
    }
    if (this.colorMatchingForm.value.brandVehicle.length >= 2) {
      this.manufacturerSub = this.apiService.getLstManufacturer(this.colorMatchingForm.value.brandVehicle).subscribe(data => {
        this.manufacturerList = data;
        if (this.manufacturerSub != null) this.manufacturerSub.unsubscribe();
      },
        error => {
          console.log(error);
        });
    }
    this.colorMatchingForm.controls["modelVehicle"].setValue("");
    this.colorMatchingForm.controls["yearVehicle"].setValue("");
  }

  selectCtcs() {
    if (this.ctcForm.value.phone.length > 0) {
      this.ctcSub = this.apiService.getLstCtc(this.ctcForm.value.phone).subscribe(
        data => {
          this.ctcList = data;
          if (this.ctcSub != null) this.ctcSub.unsubscribe();
        },
        error => {
          console.log(error);
        }
      );
    }
  }

  selectCodePostal() {
    if (this.companyForm.value.postalCode.length > 0) {
      this.companySub = this.apiService.getCodePostalCompany(this.companyForm.value.postalCode).subscribe(data => {
        this.codePostalList = data;
        if (this.companySub != null) this.companySub.unsubscribe();
      },
        error => {
          console.log(error);
        });
    }
  }

  sendAllData() {
    if (((typeof this.colorMatchingForm.value.modelVehicle != 'undefined' && this.colorMatchingForm.value.modelVehicle &&
      typeof this.colorMatchingForm.value.yearVehicle != 'undefined' && this.colorMatchingForm.value.yearVehicle &&
      document.getElementById("colorMatchingForm-modelVehicle").getAttribute("aria-required") == "true" &&
      document.getElementById("colorMatchingForm-yearVehicle").getAttribute("aria-required") == "true") ||
      (document.getElementById("colorMatchingForm-modelVehicle").getAttribute("aria-required") == "false" &&
        document.getElementById("colorMatchingForm-yearVehicle").getAttribute("aria-required") == "false")) &&
      ((document.getElementById("colorMatchingForm-designationOriginElement").getAttribute("aria-required") == "true" &&
      typeof this.colorMatchingForm.value.designationOriginElement != 'undefined' && this.colorMatchingForm.value.designationOriginElement) ||
        document.getElementById("colorMatchingForm-designationOriginElement").getAttribute("aria-required") == "false")) {

      this.colorMatchingRequest = this.colorMatchingForm.value;

      let quality = this.colorMatchingForm.value.paintQuality;
      if (quality.length > 0) {
        document.getElementById("div-matErrorCheckbox").style.display = "none";
      } else {
        document.getElementById("div-matErrorCheckbox").style.display = "block";
        return;
      }

      this.colorMatchingRequest.ctcID = 0;
      this.ctcForm.patchValue({
        idCtc: 0
      });
      this.colorMatchingRequest.ctc = this.ctcForm.value;

      this.colorMatchingRequest.userID = this.colorMatchingUser.userID;
      this.colorMatchingRequest.userCompanyID = this.colorMatchingUser.userCompanyID;
      this.colorMatchingRequest.colorUserID = this.colorMatchingUser.colorUserID;

      this.colorMatchingRequest.user = this.userForm.value;
      this.colorMatchingRequest.user.company = this.companyForm.value;

      if (this.colorMatchingForm.value.yearVehicle == "")
        this.colorMatchingRequest.yearVehicle = 0;

      if (this.colorMatchingRequest.colorOriginElement != null) {
        this.colorMatchingRequest.colorOriginElement = +this.colorMatchingRequest.colorOriginElement;
      }

      if (!this.isSend) {
        this.isSend = true;

        this.colorMatchingSub = this.apiService.addRequestColorMatching(this.colorMatchingRequest).subscribe(
          data => {
            this.idContretypage = data;
            this.colorMatchingRequest.colorMatchingID = data;
            window.setTimeout(() => { this.openModal(); }, 500);
          },
          error => {
            console.log(error);
            this.isSend = false;
          }
        );
      }
    }

  }

  print() {

      this.win = window.open("", "Title", "toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=" + (screen.width / 2) + ",height=" + (screen.height / 2) + ",top=" + (100) + ",left=" + (100));

      let printHtml = '<html><head><link rel="stylesheet" href="assets/Impression/ImpressionContretypage.css"></head><body>';
      let headerPrint = '<div class="headerPrint">' + document.getElementsByClassName("headerPrint")[0].innerHTML + '</div>';
      let reportHtml = '<div class="contentPrint">' + document.getElementsByClassName("contentPrint")[0].innerHTML + '</div>';

      printHtml += headerPrint + '<table><caption></caption><thead><tr><td> ' + "" + ' </td></tr></thead><tbody><tr><td>' + reportHtml + ' </td></tr></tbody><tfoot><tr><td><div class="headerPrint"> <img class="footerImp" src="assets/bandeau.png" alt=""/></div></td></tr></tfoot></table></body><footer></footer></html>';
      this.win.document.write(printHtml);
      this.win.document.close();

      var that = this;
      setTimeout(function () {
        that.win.print();
        that.win.close();
        that.router.navigate(['contretypage/historic']);
      }, 500);
  }

  openModal() {
    let modal = document.getElementById("finalModal");
    modal.style.display = "block";
  }

  closeModal() {
    // Ferme la modal
    let modal = document.getElementById("finalModal");
    modal.style.display = "none";
    this.router.navigate(['contretypage/historic']);
  }

}
